<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="店铺名称：" prop="shop_id">
                <el-select v-model="model.shop_id" placeholder="请选择店铺" style="width: 240px">
                    <el-option
                        v-for="item in shopList"
                        :key="'so'+item.id"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="城市：" prop="city">
                <el-input v-model="model.city" style="width: 240px"></el-input>
            </el-form-item>
            <el-form-item label="车型：" prop="model">
                <el-input v-model="model.model" style="width: 240px"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <el-input v-model="model.name" style="width: 240px"></el-input>
            </el-form-item>
            <el-form-item label="电话：" prop="phone">
                <el-input v-model="model.phone" style="width: 240px"></el-input>
            </el-form-item>
            <el-form-item label="服务内容：" prop="service">
                <el-input type="textarea" rows="4" v-model="model.service"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" rows="4" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { shopList } from '@/api/shop'

export default {
    name: 'shopSendEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                shop_id: '',
                shop_name: '',
                city: '',
                model: '',
                name: '',
                phone: '',
                service: '',
                add_time: '',
                creator: '',
            },
            getObj:{
                url:'/api/admin/shopsend/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                shop_id: [
                    {required: true, message: '店铺名称不能为空', trigger: 'blur'}
                ],
                city: [
                    {required: true, message: '城市不能为空', trigger: 'blur'}
                ],
                model: [
                    {required: true, message: '车型不能为空', trigger: 'blur'}
                ],
                name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'}
                ],
                phone: [
                    {required: true, message: '电话不能为空', trigger: 'blur'}
                ],
                service: [
                    {required: true, message: '服务内容不能为空', trigger: 'blur'}
                ],
            },
            shopList: [],
        };
    },
    methods: {
        loadOtherData() {
            shopList().then(res=>{
                if(res.code ==1){
                    this.shopList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/shopsend/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>